import React from "react";
import Header from "./header";
import Footer from "./footer/footer";
import { Sidebar } from "./sidebar";
import { Box } from "@mui/material";
import { useAuthenticator } from "@aws-amplify/ui-react";
import PublicFooter from "./footer/public-footer";
import AmplifyAuthenticator from "./authenticator";
import { useLocation } from "react-router-dom";
import { HomePage } from "../../constants/pages";

interface Props {
  children?: any;
  // any props that come into the component
}

function Layout({ children }: Props) {
  const location = useLocation();
  const [openSignIn, setOpenSignIn] = React.useState({
    open: false,
    signup: false,
  });

  const { authStatus, signOut } = useAuthenticator((context) => [context.route]);
  const handleOpen = (signup: boolean) => {
    if (authStatus !== "authenticated") {
      setOpenSignIn({
        open: true,
        signup: signup,
      });
    }
  };
  const handleClose = () => {
    setOpenSignIn({
      open: false,
      signup: false,
    });
  };
  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header route={authStatus} signOut={signOut} openSignIn={handleOpen} />

        <Box sx={{ display: "flex", flex: 1 }}>
          {![HomePage, '/policy', '/agreement-policies'].includes(location.pathname) &&
            <Sidebar route={authStatus} />
          }
          <Box sx={{ flex: 1, minWidth: 0, overflow: "auto"}}>{children(handleOpen)}</Box>
        </Box>

        {authStatus === "authenticated" || ['/policy', '/agreement-policies'].includes(location.pathname)
          ? <Footer />
          : <PublicFooter />
        }
      </Box>

      <AmplifyAuthenticator
        open={openSignIn.open}
        goToSignUp={openSignIn.signup}
        handleClose={handleClose}
      />
    </>
  );
}
export default Layout;
